// extracted by mini-css-extract-plugin
export default {"text":"ListSubItem_text__9aa4G","stopXoverflow":"ListSubItem_stopXoverflow__FX7to"};